import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { TabularReportScreen } from '@/components/tabular-report/tabular-report-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the cash position report (WP08): cash and bank balances as
 * the ledger has them, as at a date. The grant guard is presentation only.
 */
export const Route = createFileRoute('/_authenticated/accounting/reports/cash-position')({
  validateSearch: (search: Record<string, unknown>) => ({
    as_at:
      typeof search.as_at === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(search.as_at)
        ? search.as_at
        : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: CashPositionRoute,
})

function CashPositionRoute() {
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <TabularReportScreen
      path="/accounting/reports/cash-position"
      trail={[{ label: 'accounting-reports:index.title', href: '/accounting/reports' }]}
      search={Route.useSearch()}
      onSearchChange={(next) => void navigate({ search: { as_at: next.as_at } })}
      period="as_at"
      exportPermission="accounting_report.export"
    />
  )
}
